import {
  Box,
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay, Text
} from "@chakra-ui/react";
import * as React from "react";
import { CURRENCY_SYMBOLS } from "../../../utils";
import { useTranslation } from "react-i18next";
import { sortLocationsByDescTotalAmount } from "../helpers";

function PreviewSuppliersLocationsModal({ modalData, isOpen, onClose }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "suppliersLocations.previewLocationsModal"
  });
  const { countryName, countryTotalSpend, suppliers } = modalData;

  return isOpen ? (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("header")} {countryName}</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <Text fontSize="lg"><b>{countryName}</b> {t("totalSpend")}: <b>
            {countryTotalSpend && typeof countryTotalSpend !== "undefined" ?
              CURRENCY_SYMBOLS.GBP : ""}{countryTotalSpend?.toLocaleString(
            "en-GB", { maximumFractionDigits: 2 }) ?? "N/A"}
          </b>
          </Text>
          <Divider marginBlock={1} />
          <Box maxHeight={"400px"} overflow={"auto"}>
            {suppliers
              .sort((a, b) => sortLocationsByDescTotalAmount(a, b))
              .map((el, index) => {
                return <Text key={`${index}-${el.supplier}`} fontSize="md">
                  {index + 1}. {el.supplier}: <b>{el.totalAmount && typeof el.totalAmount !== "undefined" ?
                  CURRENCY_SYMBOLS.GBP : ""}{el.totalAmount?.toLocaleString(
                  "en-GB", { maximumFractionDigits: 2 }) ?? "N/A"}</b>
                </Text>;
              })}
          </Box>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            {t("closeBtn")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  ) : null;
}

export default PreviewSuppliersLocationsModal;